import { render, staticRenderFns } from "./EmployeePageTableControl.vue?vue&type=template&id=2a1fb50f&scoped=true&"
import script from "./EmployeePageTableControl.vue?vue&type=script&lang=js&"
export * from "./EmployeePageTableControl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1fb50f",
  null
  
)

export default component.exports